var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader_box"},[_c('img',{staticClass:"loader_img",attrs:{"src":"https://static-official.5i5j.com/offical/cdn/6eca4e42222d2bc1287343d1a5c7e5e9_1694743983176.png"}})])
}]

export { render, staticRenderFns }